<template>
  <auth-layout>
    <card title="Forgot Password">
      <form @submit.prevent>
        <div class="row">
          <div class="col-md-12">
            <fg-input type="email"
              placeholder="Email"
              :class="{ 'form-group--error': $v.email.$error }"
              @keyupEnter="submit"
              v-model="$v.email.$model">
            </fg-input>
          </div>
        </div>
        
        <div class="text-center">
          <p-button type="info" block
            :loading="isLoading"
            @click.native.prevent="submit">
            <span v-if="isLoading">Submitting...</span>
            <span v-else>Submit</span>
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </card>
  </auth-layout>
</template>

<script>
import AuthLayout from '../../layout/AuthLayout.vue';
import Card from '../../components/Cards/Card.vue';
import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';
import { required, email } from 'vuelidate/lib/validators';

export default {
  components: {
    AuthLayout,
    Card
  },
  data() {
    return {
      email: "",
      isLoading: false
    }
  },
  validations: {
    email: { required, email }
  },
  methods: {
    async submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        notify().error('Please enter a valid email.')
        return;
      }

      try {
        this.isLoading = true;
        await ziperase.recoverPassword(this.email);
        notify().success('Success! Please check your email to reset your password.');
      } catch (error) {
        notify().error('Failed to submit email.');
      }

      this.isLoading = false;
    }
  }
};
</script>
